import React, { useEffect, useState, useRef } from 'react';
export function DashboardHeader() {
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState<'EN' | 'FR'>('EN');
  const langDropdownRef = useRef<HTMLDivElement>(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (langDropdownRef.current && !langDropdownRef.current.contains(event.target as Node)) {
        setIsLangDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return <header className="bg-white border-b border-borderColor" data-id="element-64">
      <div className="flex justify-between items-center px-3 sm:px-6 py-3 sm:py-4" data-id="element-65">
        {/* Left side - Logo */}
        <div className="flex items-center gap-2 sm:gap-3 min-w-0" data-id="element-66">
          <div className="flex-shrink-0" data-id="element-67">
            <img src="https://cdn.magicpatterns.com/uploads/u4AKTM42BTBGHrLv1PiYxT/Logo_3.png" alt="LawVo" className="h-8 object-contain hidden lg:block" data-id="element-68" />
            <img src="https://cdn.magicpatterns.com/uploads/xxZvTa8VY3udNLg3cdpVcE/LawVo-logo-icon.png" alt="LawVo" className="h-8 w-8 object-contain lg:hidden" data-id="element-69" />
          </div>
        </div>

        {/* Right side - Language Switcher */}
        <div className="flex items-center pr-2 sm:pr-[30px]" data-id="element-70">
          <div className="relative flex-shrink-0" ref={langDropdownRef} data-id="element-71">
            <button onClick={() => setIsLangDropdownOpen(!isLangDropdownOpen)} className="flex items-center gap-1.5 px-2 py-1.5 rounded-lg hover:bg-aliceBlue transition-colors cursor-pointer" data-id="element-72">
              {currentLang === 'EN' ? <span className="text-lg leading-none" data-id="element-73">🇨🇦</span> : <img src="https://cdn.magicpatterns.com/uploads/1suDiyBW4KtwhL9yhd6pvt/Flag_of_Quebec.svg.png" alt="FR" className="w-5 h-5 object-cover rounded-sm" data-id="element-74" />}
              <span className="text-xs sm:text-sm font-semibold text-primary" data-id="element-75">
                {currentLang}
              </span>
            </button>
            {isLangDropdownOpen && <div className="absolute right-0 mt-2 w-36 bg-white rounded-lg shadow-lg overflow-hidden z-20 border border-borderColor" data-id="element-76">
                <button onClick={() => {
              setCurrentLang('EN');
              setIsLangDropdownOpen(false);
            }} className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-aliceBlue transition-colors ${currentLang === 'EN' ? 'bg-aliceBlue' : ''}`} data-id="element-77">
                  <span className="text-lg leading-none" data-id="element-78">🇨🇦</span>
                  <span className="text-sm font-medium text-primary" data-id="element-79">EN</span>
                </button>
                <button onClick={() => {
              setCurrentLang('FR');
              setIsLangDropdownOpen(false);
            }} className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-aliceBlue transition-colors ${currentLang === 'FR' ? 'bg-aliceBlue' : ''}`} data-id="element-80">
                  <img src="https://cdn.magicpatterns.com/uploads/1suDiyBW4KtwhL9yhd6pvt/Flag_of_Quebec.svg.png" alt="FR" className="w-5 h-5 object-cover rounded-sm" data-id="element-81" />
                  <span className="text-sm font-medium text-primary" data-id="element-82">FR</span>
                </button>
              </div>}
          </div>
        </div>
      </div>
    </header>;
}